import React from 'react'

import { useTimerRef } from '@libs/typescript-utils'

export const COPY_FEEDBACK_STATUS = {
  copied: 'copied',
  error: 'error',
} as const

export type CopyFeedbackStatus = ConstObjectValues<typeof COPY_FEEDBACK_STATUS>

const FEEDBACK_DURATION = 1500

/** Copy result state for {@link CopyFeedbackIcon}, falling back to the idle icon after a short delay. */
export function useCopyFeedback() {
  const [status, setStatus] = React.useState<Nullable<CopyFeedbackStatus>>(null)
  const timerRef = useTimerRef()

  const onCopy = React.useCallback(
    (text: string, result: boolean) => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current)
      }
      setStatus(result ? COPY_FEEDBACK_STATUS.copied : COPY_FEEDBACK_STATUS.error)
      timerRef.current = window.setTimeout(() => {
        setStatus(null)
      }, FEEDBACK_DURATION)
    },
    [timerRef]
  )

  return { onCopy, status }
}
